import {AxiosInstance} from "axios";
import {CodatErrorApiDto} from "./model/rest";
import WorkspaceContainer from "../components/v5/table/workspace/WorkspaceContainer";

/**
 * Codat Errors Api.
 */
export default class CodatErrorsApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch Codat errors
	 * @returns {Promise}
	 */
	fetchErrors(page: number): Promise<{ items: CodatErrorApiDto[], totalItems: number }> {
		const url = `/api/web/accounting/codat_errors`;
		const params = {params: {page: page - 1, size: WorkspaceContainer.PAGE_SIZE}};
		return this.axiosInstance.get(url, params).then(resp => resp.data);
	}

	/**
	 * Mark Error as resolved
	 */
	markErrorAsSolved(errorId: string) {
		const url = `/api/web/accounting/codat_errors/${errorId}/solve`;
		return this.axiosInstance.put(url);
	}
}
